import ClickableRateCardList, { ClickableRateCardListProps } from './ClickableRateCardList';

export type { ClickableRateCardListProps };
export default ClickableRateCardList;
